module.exports = __webpack_public_path__ + "files/6dfac48f710b6ca059d98f89093ab89c.png";